import React, { ImgHTMLAttributes } from 'react';
import './floatingEventInfo.module.scss';
import iconPlace from '../../course/images/icon-place.png';
import iconCalendar from '../../course/images/icon-calendar.png';
import iconMoney from '../../course/images/icon-money.png';
import { SimpleDate, SimpleTimeRange } from '../../../../admin/components/date/TimeRange';
import { ReserverType } from '../states/EventReservationPageState';
import { EventDetails, UserEventReservationStatus } from '../../../types/event';
import { getLocationName } from '../../../../mainv3/types/location';
import { EventStatusUtils } from '../../event/utils/EventStatusUtils';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';

const Section = ({ children }: { children: React.ReactNode }) => <div styleName="section">{children}</div>;
const SectionIcon = ({ src }: { src: ImgHTMLAttributes<HTMLImageElement>['src'] }) => (
  <div styleName="icon-container">
    <img src={src} styleName="icon" />
  </div>
);

const LessonDate = ({ event }: { event: EventDetails }) => {
  return (
    <Section>
      <SectionIcon src={iconCalendar} />
      <div styleName="date">
        <SimpleDate date={event.starts_at} />
        <br />
        <SimpleTimeRange range={event} />
      </div>
    </Section>
  );
};

const CourseLocation = ({ locationName }: { locationName: string }) => {
  return (
    <Section>
      <SectionIcon src={iconPlace} />
      <div styleName="location-name">{locationName}</div>
    </Section>
  );
};

type PriceProps = { event: EventDetails; userEventReservationStatus: UserEventReservationStatus };

const Price = ({ event, userEventReservationStatus }: PriceProps) => {
  if (EventStatusUtils.isEventFreeForUser(event, userEventReservationStatus, GlobalStatesV3.currentUser.currentUser)) {
    return null;
  }
  const { applied_price, price_with_tax } = event;
  return (
    <Section>
      <SectionIcon src={iconMoney} />
      <div>
        {applied_price > 0 ? (
          <span>
            <span styleName="price">{applied_price.toLocaleString()}</span>円（税込 {price_with_tax.toLocaleString()}
            円）
          </span>
        ) : (
          <span>無料</span>
        )}
      </div>
    </Section>
  );
};

type Props = {
  event: EventDetails;
  reserverType: ReserverType;
  userEventReservationStatus: UserEventReservationStatus;
};

export const FloatingEventInfo = (props: Props) => {
  const { event, userEventReservationStatus } = props;
  return (
    <div styleName="floating-lesson-info">
      <div styleName="body">
        <LessonDate event={event} />
        <CourseLocation locationName={getLocationName(event.location)} />
        <Price event={event} userEventReservationStatus={userEventReservationStatus} />
      </div>
    </div>
  );
};
